import { SIZES, WEIGHT_UNIT } from './constants';
const convertToMl = (weightItem) => {
    const [amount, unit] = weightItem.split(' ');
    if (unit === WEIGHT_UNIT.milliliter) {
        return parseInt(amount, 10);
    }
    if (unit === WEIGHT_UNIT.litre) {
        return parseInt(amount, 10) * 1000;
    }
    return 0;
};
const sortSizes = (a, b) => SIZES.indexOf(a) - SIZES.indexOf(b);
const sortWeight = (a, b) => convertToMl(a) - convertToMl(b);
export const getSizesValue = (listOptions, isYamalube) => listOptions.sort(isYamalube ? sortWeight : sortSizes).map((item) => ({
    key: item,
    value: item,
}));
export const sortArray = (arr) => {
    return arr.sort((a, b) => Number(a) - Number(b));
};
